export default __webpack_public_path__ + "static/Hover_Materials-211deda354a084a8f2696249f434de63.mp4";